import React from "react";
import QuestionDetailsComponent from "./QuestionDetailsComponent";
class SingleLineTextComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
      pattern: `[0]{1}[0-9]{2}[-]{1}[0-9]{7}`,
      pattern2: `[0]{1}[0-9]{2}[0-9]{7}`,
    };
    this.handleBlur = this.handleBlur.bind(this);
  }

  handleBlur(e) {
    this.setText(e.target.value);
    this.props.setAnswer(this.props, e);
  }

  setText = (v) => {
    this.setState({ text: v });
  }

  render() {
    const { question, answer } = this.props;
    const { value } = answer;
    const text = this.state.text ? this.state.text : value;
   
    const { elementKey, questionContent } = question;
    const { helpText } = questionContent;
    let condPattern = '';

    if (elementKey === '31548331-612F-4676-A67D-0B9C62F428B0') {
      condPattern = '[A-Za-z]{2}[0-9]{9}[A-Za-z]{2}';
    }

    const handleChange = (e, cond) => {
      const questionMain = document.getElementById(`${elementKey}`);
      const question_header = questionMain.querySelector('.question_header');
      const button_next = document.querySelector('.button_next');
      const error_message = questionMain.querySelectorAll('.error_message');
      const { pattern, pattern2 } = this.state;
      const phoneNumber = document.getElementById('phone3F0CFABA-6077-4B63-9F1B-74A3430500AA');
      const phoneNumberValue = phoneNumber.value;
      const scope = phoneNumber.closest('.question');
      const error = scope.querySelectorAll('.error_message');

      error_message && error_message.forEach((item) => item.remove());
      
      error && error.forEach((item) => item.remove());

      if (cond && e.target.value) {
        if (e.target.value.match(cond) && e.target.value.length === 13) {
          if (phoneNumberValue && (phoneNumberValue.length === 10 || phoneNumberValue.length === 11) && (phoneNumberValue.match(pattern) || phoneNumberValue.match(pattern2))) {
            button_next.removeAttribute('disabled');
            // this.props.setAnswer(this.props, e);
          } else if (!phoneNumberValue) {
            button_next.removeAttribute('disabled');
            // this.props.setAnswer(this.props, e);
          } else {
            button_next.disabled = true;
            const html = `<div class="error_message">กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง ตัวอย่าง 0811234567</div>`;
            scope.querySelector('.question_header').insertAdjacentHTML('afterend', html);
          }
        } else {
          button_next.disabled = true;
          const html = `<div class="error_message">กรุณากรอกหมายเลขพัสดุ 13 หลัก ตัวอย่าง EF582621151TH</div>`;
          question_header.insertAdjacentHTML('afterend', html);
        }
      } else {
        if (phoneNumberValue && (phoneNumberValue.length === 10 || phoneNumberValue.length === 11) && (phoneNumberValue.match(pattern) || phoneNumberValue.match(pattern2))) {
          button_next.removeAttribute('disabled');
        } else if (!phoneNumberValue) {
          button_next.removeAttribute('disabled');
        } else {
          error && error.forEach((item) => item.remove());
          button_next.disabled = true;
          const html = `<div class="error_message">กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง ตัวอย่าง 0811234567</div>`;
          scope.querySelector('.question_header').insertAdjacentHTML('afterend', html);
        }
        // this.props.setAnswer(this.props, e);
      }

      this.setText(e.target.value);
      this.props.setAnswer(this.props, e);
    }

    return (
      <div id={`${elementKey}`} className={`question text_singleline`}>
        <QuestionDetailsComponent {...this.props} />
        <div className="question_element">
          {
            (elementKey === '31548331-612F-4676-A67D-0B9C62F428B0') ? 
            <input
              id={`singleline${elementKey}`}
              type="text"
              defaultValue={text}
              onBlur={(e) => handleChange(e, condPattern)}
              placeholder={helpText}
              pattern={condPattern}
            />
            : <input
              id={`singleline${elementKey}`}
              type="text"
              defaultValue={value}
              onBlur={e=>this.handleBlur(e)}
              placeholder={helpText}
              pattern={condPattern}
            />
          }
        </div>
      </div>
    );
  }
}

export default SingleLineTextComponent;
